import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
import ConfigurableCallWidget from './ConfigurableCallWidget';
import { chooseConfig } from 'flow/utils/call-widget-utils';
import { jsx as _jsx } from "react/jsx-runtime";
var CallWidget = function CallWidget(_ref) {
  var discriminator = _ref.discriminator,
    present = _ref.present,
    missing = _ref.missing,
    variables = _ref.variables,
    darkMode = _ref.darkMode,
    width = _ref.width;
  var config = chooseConfig(discriminator, variables, present, missing);
  return /*#__PURE__*/_jsx(ConfigurableCallWidget, {
    config: config,
    variables: variables,
    darkMode: darkMode,
    width: width
  });
};
CallWidget.defaultProps = {
  darkMode: true
};
CallWidget.propTypes = {
  discriminator: PropTypes.string,
  present: PropTypes.shape(_objectSpread({}, ConfigurableCallWidget.propTypes)),
  missing: PropTypes.shape(_objectSpread({}, ConfigurableCallWidget.propTypes)),
  variables: PropTypes.object,
  // eslint-disable-line
  darkMode: PropTypes.bool,
  width: PropTypes.number
};
export default /*#__PURE__*/React.memo(CallWidget);